const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};

const NEW_VIEW_TOTAL = 348258;
const DATA_POINT_VIEWS = 329561;

const SCALE_FACTOR = (NEW_VIEW_TOTAL / DATA_POINT_VIEWS);


module.exports.reportData = {
  info: {
    campaignName: 'VOXI Endless Challenge',
    influencerName: 'Callux, Caspar Lee and Oli White',
    reportDate: new Date('2018-04-16'),
    hasLogo: true,
    campaignHashTag: '#VOXIendlesschallenge',
    campaignSponsorHandle: '@VOXI_UK',
    campaignArchive: 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/campaign-archives/voxi-caspar.zip',
  },
  youtubeViews: NEW_VIEW_TOTAL,
  youtubeEngagements: 21121 * SCALE_FACTOR,
  scaleFactor: SCALE_FACTOR,
  heroData: {
    main: {
      title: 'SPOONING MY ROOMMATE PRANK!!',
      subTitle: `Let the spooning begin! #VOXIendlesschallenge! #TEAMCASPAR
- Grab my exclusive SIM pack here - http://www.voxi.co.uk/casparlee
- This video is part of a sponsored collaboration with VOXI`,
      videoUrl: 'https://www.youtube.com/watch?v=7iOHSvWIRtc',
      views: NEW_VIEW_TOTAL,
      engagements: 21121 * SCALE_FACTOR,
      watchTimeUKIre: 448019 * SCALE_FACTOR,
      watchTimeTotal: 1126206 * SCALE_FACTOR,
      scaleFactor: SCALE_FACTOR,
      donutData: {
        labels: [
          'male %',
          'female %',
        ],
        datasets: [{
          data: [20.5, 79.5],
          backgroundColor: [
            dyzioPalette.bgPink,
            dyzioPalette.bgGreen,
          ],
          borderColor: [
            dyzioPalette.pink,
            dyzioPalette.green,
          ],
          borderWidth: 1,
        }],
      },
      barData: {
        labels: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '64+'],
        datasets: [
          {
            label: 'male %',
            backgroundColor: dyzioPalette.bgPink,
            borderColor: dyzioPalette.pink,
            borderWidth: 1,
            data: [2.2, 9.2, 5.8, 1.7, 1.4, 0.2, 0.2],
          },
          {
            label: 'female %',
            backgroundColor: dyzioPalette.bgGreen,
            borderColor: dyzioPalette.green,
            borderWidth: 1,
            data: [15.8, 40.6, 13.5, 4.8, 3.9, 0.4, 0.5],
          },
        ],
      },
      viewingData: [{
        name: 'United Kingdom',
        watchTime: 418202,
        views: 121394,
        likes: 7591,
      },
      {
        name: 'United States',
        watchTime: 192575,
        views: 55420,
        likes: 3565,
      },
      {
        name: 'Australia',
        watchTime: 96206,
        views: 26168,
        likes: 1625,
      },

      {
        name: 'Canada',
        watchTime: 39244,
        views: 11082,
        likes: 652,
      },
      {
        name: 'Ireland',
        watchTime: 29817,
        views: 8788,
        likes: 590,
      },
    ],
    },
    supportingData: {
      labels: [
        'instagram',
        'instagram STORY',
        'twitter',
      ],
      datasets: [{
        data: [0, 107628, 593116],
        backgroundColor: [
          dyzioPalette.bgPink,
          dyzioPalette.bgGreen,
          dyzioPalette.blue,
        ],
        borderColor: [
          dyzioPalette.pink,
          dyzioPalette.green,
          dyzioPalette.bgBlue,
        ],
        borderWidth: 1,
      }],
    },
  },
};



// WEBPACK FOOTER //
// ./src/containers/campaign-report/data/voxi-endless-challenge-2018-caspar.js